module.exports = __webpack_public_path__ + "static/media/infoIcon.f60914e0.svg";